<script>
export default {
	data() {
		return {
			isScrolled: false,
			isSidebarOpen: false, // Track the sidebar state
			isMobileView: window.innerWidth <= 991, // Track screen width for responsive behavior
		}
	},
	mounted() {
		// Add scroll and resize event listeners when the component is mounted
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("resize", this.handleResize);
	},
	beforeUnmount() {
		// Remove the scroll and resize event listeners when the component is about to be unmounted
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleResize);
	},
	methods: {
        toggleSidebar() {
			// Only toggle sidebar and class if screen width is 991px or below
            if (this.isMobileView) {
				this.isSidebarOpen = !this.isSidebarOpen;
				document.documentElement.classList.toggle("menu-opened");
			}
        },
        closeSidebar() {
			// Only close sidebar and remove class if screen width is 991px or below
			if (this.isMobileView) {
				this.isSidebarOpen = false;
				document.documentElement.classList.remove("menu-opened");
			}
        },
		handleScroll() {
			// Get the scroll position
			const scroll = window.scrollY;

			// Update the isScrolled data property based on the scroll position
			this.isScrolled = scroll > 35;
		},
		handleResize() {
			// Update the isMobileView property based on the window width
			this.isMobileView = window.innerWidth <= 991;
		},
		getHeaderClass() {
			const path = this.$route.path;
			// Set class based on path and scroll status
			return {                    
				'header-new': path === '/home/index',
				'header-one': path === '/home/index-2',
				'header-two': path === '/home/index-3',
				'header-three': path === '/home/index-4',
				'header-four': path === '/home/index-5',
				'header-six': path === '/home/index-6',
				'header-nine': path === '/home/index-7',
				'header-eight': path === '/home/index-8',
				'header-five': path === '/home/index-9',
				'header-seven': path === '/home/index-10',
				'fixed': this.isScrolled,
			};
		}   
	},
	computed: {
		isHomeOneRoute() {
			return  this.$route.path === "/home/index";
		},
		isHomeTwoRoute() {
			return this.$route.path === "/home/index-2" ||
				this.$route.path === "/pages/about-us" ||
				this.$route.path === "/blogs/blog-grid" ||
				this.$route.path === "/blogs/blog-list" ||
				this.$route.path === "/blogs/blog-details" ||
				this.$route.path === "/booking/booking-success" ||
				this.$route.path === "/booking/user-booking" ||
				this.$route.path === "/booking/booking-details" ||
				this.$route.path === "/booking/booking-payment" ||
				this.$route.path === "/booking/invoice" ||
				this.$route.path === "/pages/categories" ||
				this.$route.path === "/pages/contact-us" ||
				this.$route.path === "/pages/faq" ||
				this.$route.path === "/pages/how-it-works" ||
				this.$route.path === "/pages/pricing" ||
				this.$route.path === "/pages/privacy-policy" ||
				this.$route.path === "/pages/notification" ||
				this.$route.path === "/service/services-grid" ||
				this.$route.path === "/service/services-list" ||
				this.$route.path === "/details/service-details" ||
				this.$route.path === "/details/service-details-two" ||
				this.$route.path === "/service/search" ||
				this.$route.path === "/service-provider/providers" ||
				this.$route.path === "/service-provider/provider-details" ||
				this.$route.path === "/service-categories/categories" ||
				this.$route.path === "/service-categories/categories-2" ||
				this.$route.path === "/service/create-service" ||
				this.$route.path === "/service/service-request";
		},
		isHomeThreeRoute() {
			return this.$route.path === "/home/index-3";
		},
		isHomeFourRoute() {
			return this.$route.path === "/home/index-4";
		},
		isHomeFiveRoute() {
			return this.$route.path === "/home/index-5";
		},
		isHomeSixRoute() {
			return this.$route.path === "/home/index-6";
		},
		isHomeSevenRoute() {
			return this.$route.path === "/home/index-7";
		},
		isHomeEightRoute() {
			return this.$route.path === "/home/index-8";
		},
		isHomeNineRoute() {
			return this.$route.path === "/home/index-9";
		},
		isHomeTenRoute() {
			return this.$route.path === "/home/index-10";
		},
		isCustomerRoute() {
			return this.$route.path === "/customer/user-dashboard" ||
			this.$route.path === "/customer/user-booking-list" ||
			this.$route.path === "/customer/user-bookings-calendar" ||
			this.$route.path === "/customer/favourites" || 
			this.$route.path === "/customer/customer-wallet" ||
			this.$route.path === "/customer/customer-reviews" ||
			this.$route.path === "/customer/user-chat" || 
			this.$route.path === "/customer-settings/account-settings" ||
			this.$route.path === "/customer-settings/security-settings" || 
			this.$route.path === "/customer-settings/notification-settings" || 
			this.$route.path === "/customer-settings/device-managment" || 
			this.$route.path === "/customer-settings/login-activity" || 
			this.$route.path === "/customer-settings/connected-apps"; 
		},
	},
}
</script>

<template>
	<div :class="['sidebar-overlay', { opened: isSidebarOpen && isMobileView }]"></div>
	
	<header class="header" :class="getHeaderClass()">
		<div :class="[$route.path === '/home/index' ? 'container-fluid' : 'container']">
			<nav class="navbar navbar-expand-lg header-nav">
				<div class="navbar-header">
					<a id="mobile_btn" href="javascript:void(0);" @click="toggleSidebar">
						<span class="bar-icon">
							<span></span>
							<span></span>
							<span></span>
						</span>
					</a>
					<router-link to="/home/" class="navbar-brand logo">
						<img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
					</router-link>
					<router-link to="/home/" class="navbar-brand logo-small">
						<img src="@/assets/img/logo-small.svg" class="img-fluid" alt="Logo">
					</router-link>
				</div>
				<div class="main-menu-wrapper">
					<div class="menu-header">
						<router-link to="/home/" class="menu-logo">
							<img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
						</router-link>
						<a id="menu_close" class="menu-close" href="javascript:void(0);" @click="closeSidebar"> <i class="fas fa-times"></i></a>
					</div>
					<header-menu></header-menu>
				</div>
                <ul class="nav header-navbar-rht" v-if="isHomeOneRoute">
					<li class="nav-item pe-1">
						<a class="nav-link btn btn-light" href="#" data-bs-toggle="modal" data-bs-target="#login-modal"><i class="ti ti-lock me-2"></i>Sign In</a>
					</li>
					<li class="nav-item">
						<a class="nav-link btn btn-linear-primary" href="#" data-bs-toggle="modal" data-bs-target="#register-modal"><i class="ti ti-user-filled me-2"></i>Join Us</a>
					</li>
				</ul>
                <ul class="nav header-navbar-rht" v-if="isHomeTwoRoute">
                    <li class="nav-item">
                        <router-link class="nav-link header-reg" to="/register">Register</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link header-login" to="/"><i class="fa-regular fa-circle-user me-2"></i>Login</router-link>
                    </li>
                </ul>
                <ul class="nav header-navbar-rht" v-if="isHomeThreeRoute">
                    <li class="nav-item">
                        <router-link class="nav-link header-login" to="/"><i class="feather-user"></i> Register / Login</router-link>
                    </li>
                </ul>
                <ul class="nav header-navbar-rht" v-if="isHomeFourRoute">
                    <li class="nav-item">
                        <router-link class="nav-link header-login" to="/register"><i class="feather-calendar me-2"></i>APPOINTMENT</router-link>
                    </li>
                    <li class="nav-item">
                        <div class="cta-btn">
                        <router-link class="btn" to="/register"><i class="feather-users me-2"></i>REGISTER /</router-link>
                        <router-link class="btn ms-1" to="/">LOGIN</router-link>
                        </div>
                    </li>
                </ul>
				<ul class="nav header-navbar-rht" v-if="isHomeFiveRoute">
					<li class="nav-item">
						<router-link class="nav-link header-login" to="/"><i
								class="feather-users me-2"></i>Login</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link header-login" to="/register"><i
								class="feather-users me-2"></i>Register</router-link>
					</li>
				</ul>
                <ul class="nav header-navbar-rht" v-if="isHomeSixRoute">
                    <li class="nav-item">
                        <router-link class="nav-link header-button-six" to="/register"><i
                                class="feather-user-plus me-2"></i>Register</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link header-button-six" to="/"><i
                                class="feather-log-in me-2"></i>Login</router-link>
                    </li>
                </ul>
                <ul class="nav header-navbar-rht header-navbar-rht-nine" v-if="isHomeSevenRoute">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">Become A Professional</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">Become A User</router-link>
                    </li>
                </ul>
				<ul class="nav header-navbar-rht" v-if="isHomeEightRoute">
						<li class="nav-item">
							<router-link class="nav-link header-login" to="/"><i class="feather-log-in me-2"></i>Login</router-link>
						</li>
						<li class="nav-item">
							<router-link class="nav-link header-login" to="/register"><i class="feather-user-plus me-2"></i>Register</router-link>
						</li>
					</ul>
                <ul class="nav header-navbar-rht" v-if="isHomeNineRoute">
                    <li class="nav-item">
                        <router-link class="nav-link header-reg register" to="/register">Register</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link header-login" to="/"><i class="feather-user me-2"></i>Login</router-link>
                    </li>
                </ul>
				<ul class="nav header-navbar-rht" v-if="isHomeTenRoute">
					<li class="nav-item">
						<router-link class="nav-link header-login" to="/register"><i
								class="feather-user me-2"></i>Register</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link header-login" to="/"><i
								class="feather-user me-2"></i>Login</router-link>
					</li>
				</ul>
                <div class="header-btn d-flex align-items-center" v-if="isCustomerRoute">
					<div class="provider-head-links">
						<a href="javascript:void(0);" class="d-flex align-items-center justify-content-center me-2 notify-link" data-bs-toggle="dropdown"><i class="feather-bell"></i></a>
						<div class="dropdown-menu dropdown-menu-end notification-dropdown p-4">
							<div class="d-flex dropdown-body align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
								<h6 class="notification-title">Notifications <span class="fs-18 text-gray"> (2)</span></h6>
								<div class="d-flex align-items-center">
									<a href="#" class="text-primary fs-15 me-3 lh-1">Mark all as read</a>
									<div class="dropdown">
										<a href="javascript:void(0);" class="bg-white dropdown-toggle"
											data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="ti ti-calendar-due me-1"></i>Today
										</a>
										<ul class="dropdown-menu mt-2 p-3">
											<li>
												<a href="javascript:void(0);" class="dropdown-item rounded-1">
													This Week
												</a>
											</li>
											<li>
												<a href="javascript:void(0);" class="dropdown-item rounded-1">
													Last Week
												</a>
											</li>
											<li>
												<a href="javascript:void(0);" class="dropdown-item rounded-1">
													Last Week
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>

							<div class="noti-content">
								<div class="d-flex flex-column">
									<div class="border-bottom mb-3 pb-3">
										<router-link to="/pages/notification">
											<div class="d-flex">
												<span class="avatar avatar-lg me-2 flex-shrink-0">
													<img src="@/assets/img/profiles/avatar-52.jpg" alt="Profile" class="rounded-circle">
												</span>
												<div class="flex-grow-1">
													<div class="d-flex align-items-center">
													<p class="mb-1 w-100"><span class="text-dark fw-semibold">Stephan Peralt</span> rescheduled the service to 14/01/2024. </p>
													<span class="d-flex justify-content-end "> <i class="ti ti-point-filled text-primary"></i></span>
													</div> 
													<span>Just Now</span>
												</div>
											</div>
										</router-link>
									</div>
									<div class="border-bottom mb-3 pb-3">
										<router-link to="/pages/notification" class="pb-0">
											<div class="d-flex">
												<span class="avatar avatar-lg me-2 flex-shrink-0">
													<img src="@/assets/img/profiles/avatar-36.jpg" alt="Profile" class="rounded-circle">
												</span>
												<div class="flex-grow-1">
													<div class="d-flex align-items-center">
														<p class="mb-1 w-100"><span class="text-dark fw-semibold">Harvey Smith</span> has requested your service.</p>
														<span class="d-flex justify-content-end "> <i class="ti ti-point-filled text-primary"></i></span>
													</div>
													<span>5 mins ago</span>
													<div class="d-flex justify-content-start align-items-center mt-2">
														<span class="btn btn-light btn-sm me-2">Deny</span>
														<span class="btn btn-dark btn-sm">Accept</span>
													</div>
												</div>
											</div>
										</router-link>					
									</div>
									<div class="border-bottom mb-3 pb-3">
										<router-link to="/pages/notification">
											<div class="d-flex">
												<span class="avatar avatar-lg me-2 flex-shrink-0">
													<img src="@/assets/img/profiles/avatar-02.jpg" alt="Profile" class="rounded-circle">
												</span>
												<div class="flex-grow-1">
													<p class="mb-1"><span class="text-dark fw-semibold"> Anthony Lewis</span> has left feedback for your recent service </p>
													<span>10 mins ago</span>
												</div>
											</div>
										</router-link>
									</div>
									<div class="border-0 mb-3 pb-0">
										<router-link to="/pages/notification">
											<div class="d-flex">
												<span class="avatar avatar-lg me-2 flex-shrink-0">
													<img src="@/assets/img/profiles/avatar-22.jpg" alt="Profile" class="rounded-circle">
												</span>
												<div class="flex-grow-1">
													<p class="mb-1"><span class="text-dark fw-semibold">Brian Villaloboshas </span> cancelled the service scheduled for 14/01/2024.
													</p>
													<span>15 mins ago</span>
												</div>
											</div>
										</router-link>
									</div>
								</div>
							</div>
							<div class="d-flex p-0 notification-footer-btn">
								<a href="#" class="btn btn-light rounded  me-2">Cancel</a>
								<a href="#" class="btn btn-dark rounded ">View All</a>
							</div>
						</div>
					</div>
					<div class="provider-head-links">
						<router-link to="/customer/user-chat" class="d-flex align-items-center justify-content-center me-2"><i class="feather-mail"></i></router-link>
					</div>
					<div class="dropdown">
						<a href="javascript:void(0);" data-bs-toggle="dropdown" aria-expanded="false" class="">
							<div class="booking-user d-flex align-items-center">
								<span class="user-img">
									<img src="@/assets/img/profiles/avatar-02.jpg" alt="user">
								</span>
							</div>
						</a>
						<ul class="dropdown-menu p-2">
							<li><router-link class="dropdown-item d-flex align-items-center" to="/"><i class="ti ti-logout me-1"></i>Logout</router-link></li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</header>
	
    <index-modal></index-modal>
</template>